
import {Component, Vue} from "vue-property-decorator";
import vBreadcrumbs from "@/components/vBreadcrumbs.vue";
import vGrandfatheredSubscriptionWarningModal from "@/components/vGrandfatheredSubscriptionWarningModal.vue";
import vRetentionCancellationFlow from "@/components/vRetentionCancellationFlow.vue";
import {mapState} from "vuex";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import {AddOnType} from "@/models/Subscriptions/AddOns/AddOnType";
import {AddOnTypeName} from "@/models/Subscriptions/AddOns/AddOnTypeName";
import {FETCH_USER_DETAILS, TRANSLATIONS_FETCH} from "@/store/ActionTypes";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import CancellationWorkflowRepository from "@/utils/API/CancellationWorkflowRepository";
import {SubscriptionRecurrenceType} from "@/models/Subscriptions/SubscriptionRecurrenceType";
import vPackageCard from "@/components/vPackageCard.vue";
import vCarousel from "@/components/vCarousel.vue";
import vPreLoader from "@/components/vPreLoader.vue";
import {dateDisplayFormat} from "@/utils/Defaults";
import vToggleSwitch from "@/components/vToggleSwitch.vue";
import CouponsRepository from "@/utils/API/CouponsRepository";
import {round} from "@/utils/Helpers";
import vModal from "@/components/vModal.vue";
import {SubscriptionStatus} from "../../models/Subscriptions/SubscriptionStatus";
import {PaymentProvider} from "../../models/Subscriptions/PaymentProvider";
import {
  SubscriptionMigrationTypeEnum
} from "../../models/Subscriptions/SubscriptionPackages/SubscriptionMigrationTypeEnum";
import CheckSubscriptionMigration from "@/models/Subscriptions/SubscriptionPackages/CheckSubscriptionMigration";
import {UserLicensesPrice} from "@/models/Subscriptions/UserLicenses/UserLicensesPrice";
import vPaymentMethods from "@/components/vPaymentMethods.vue";
import {UserTypes} from "../../models/User/UserTypes";
import {NutrientSource} from "@/models/NutrientSource/NutrientSource";

import RecipesRepository from "@/utils/API/RecipesRepository";
import {ExitSurveyDto} from "@/models/Subscriptions/ExitSurveyDto";
import VTrialEndUpsellModal from "@/components/modals/marketing/vTrialEndUpsellModal.vue";
import vUpsellModal from "@/components/modals/marketing/vUpsellModal.vue";
import {AccountState} from "@/store/modules/AccountModule";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import SubscribeToPackageForm from "@/components/forms/SubscribeToPackageForm.vue";
import {CustomerCreationMode} from "@/models/Customer/CustomerCreationMode";
import VPaymentMethods from "@/components/vPaymentMethods.vue";

@Component({
  components: {
    VPaymentMethods,
    SubscribeToPackageForm,
    vUpsellModal,
    VTrialEndUpsellModal,
    vBreadcrumbs,
    vPackageCard,
    vCarousel,
    vPaymentMethods,
    vModal,
    vPreLoader,
    vToggleSwitch,
    vGrandfatheredSubscriptionWarningModal,
    vRetentionCancellationFlow
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
class ManageSubscription extends Vue {
  localizationState: LocalizationState;
  accountState: AccountState;

  packages: Package[] = [];
  paymentMode = SubscriptionRecurrenceType.Yearly;
  showCarouselPreloader = false;
  dateDisplayFormat = dateDisplayFormat;
  showCancellationSurveyModal = false;
  showChangeSubscriptionWarningModal = false;
  showRemoveAddOnModal = false;
  removeAddOnId: any = null;
  removeSugarAlcoholAddOnWarning: boolean = false;
  switchToggle: boolean = true;
  addOns: any[] = [];
  couponCode: string = "";
  coupon: any = null;
  paymentLoading: boolean = false;

  restaurantNotificationEmail: string = this.$store.getters.getUserDetails.restaurantNotificationEmail;
  isAddingNewPaymentMethod: boolean = false;

  paymentModalOpen: boolean = false;
  addAddonsModalOpen: boolean = false;
  addOrRemoveLicensesModalOpen: boolean = false;
  round = round;
  subscriptionStatusEnum = SubscriptionStatus;
  paymentProviderEnum = PaymentProvider;
  subscriptionCycleEnum = SubscriptionRecurrenceType;
  addOnTypeNameEnum = AddOnTypeName;
  subscriptionMigrationDto: any = null;
  futureSubscriptions: any[] = [];
  addOnsToBuy: any[] = [];
  futureSubscriptionId: number = 0;
  showFutureSubscriptionDetailsModal = false;
  futureSubscription: any = null;
  payingUserLicenses: number = 0;
  addOrRemoveLicensesCount: number = 0;
  userLicensesPriceDto: UserLicensesPrice = {
    originalPrice: 0,
    actualPrice: 0,
  };
  chosenPaymentMethodId: number = -1;
  paymentMethodToEdit: number = -1;

  paymentProcessInterval: any = null;
  transveringSubscriptionId: string = null;
  transveringPaymentCost: number = null;
  isTransferingPaymentProviderModalOpen: boolean = false;
  subscriptionLoader: boolean = false;

  // make accessible in the template
  UserTypes = UserTypes;

  /**
   * A flag indicating whether to display the upsell modal at the end of a trial period.
   *
   * This variable is used to control the visibility of a modal that prompts users
   * to consider upgrading or extending their subscription once their trial period concludes.
   * When set to `true`, the upsell modal is shown; when set to `false`, it is hidden.
   *
   * Default value is `false`.
   */
  showTrialEndUpsellModal = false;

  /**
   * Hides the trial end upsell modal by setting the visibility status to false.
   *
   * @return {void} This method does not return a value.
   */
  hideTrialEndUpsellModal() {
    this.showTrialEndUpsellModal = false;
  }

  showTrialUpsellModal: boolean = false;

  closeTrialUpsellModal() {
    this.showTrialUpsellModal = false;
  }

  handleAddingNewPaymentMethod(state: boolean) {
    this.isAddingNewPaymentMethod = state;
  }

  // Choose monthly or yearly
  toggleMonthlyOrYearly() {
    this.switchToggle = !this.switchToggle;
    if (this.switchToggle === true) {
      this.setPaymentMode(1);
    }
    else {
      this.setPaymentMode(0);
    }
  }

  setPaymentMethod(paymentMethodId : number) {
    this.chosenPaymentMethodId = paymentMethodId;
  }

  get isActiveAndAutoRenewing() {
    return (
      this.accountState.userDetails.subscriptionStatus ===
      this.subscriptionStatusEnum.Active &&
      this.accountState.userDetails.isRecurring
    );
  }

  get userPackage() {
    if (this.chosenUserPackage) {
      return this.chosenUserPackage;
    }
    let userPackage = this.packages.find(
      (p) => p.id === this.accountState.userDetails.subscriptionPackageId
    );
    return userPackage;
  }

  get userSubscriptionPackage() {
    if (this.chosenUserPackage) {
      return this.chosenUserPackage;
    }
    let userPackage = this.packages.find(
      (p) =>
        p.externalId ===
        this.accountState.userDetails.subscriptionPackageExternalId &&
        p.cycle == this.accountState.userDetails.subscriptionCycle
    );
    return userPackage;
  }

  get chosenUserPackage() {
    if (this.$route.params.id) {
      let chosenUserPackageId = parseInt(this.$route.params.id);
      if (chosenUserPackageId) {
        let chosenUserPackage = this.packages.find(
          (x) => x.id == chosenUserPackageId
        );
        if (chosenUserPackage) {
          return chosenUserPackage;
        }
      }
    }
    return null;
  }

  get isUpgrade() {
    return (
      this.subscriptionMigrationDto != null &&
      this.subscriptionMigrationDto.subscriptionMigrationType ===
      SubscriptionMigrationTypeEnum.Upgrade
    );
  }

  get isDowngrade() {
    return (
      this.subscriptionMigrationDto != null &&
      this.subscriptionMigrationDto.subscriptionMigrationType ===
      SubscriptionMigrationTypeEnum.Downgrade
    );
  }

  get isAddingLicenses() {
    return this.addOrRemoveLicensesCount > this.paidUserLicences;
  }

  subscriptionPackageChosen(packageId: Number) {
    this.$router.push({
      name: "subscriptionPay",
      params: {
        id: packageId.toString(),
        subscriptionCycle: this.paymentMode.toString(),
      },
    });

    this.openPaymentModal();
  }

  //Added addons original price
  get addedAddonsPrice() {
    if (this.addOnsToBuy != null && this.addOnsToBuy.length > 0) {
      let sum = 0;
      for (let addOn of this.addOnsToBuy) {
        if (addOn.checked) {
          sum += addOn.originalPrice;
        }
      }
      return sum;
    }
    return 0;
  }

  //Added addons actual price
  get addedAddonsActualPrice() {
    if (this.addOnsToBuy != null && this.addOnsToBuy.length > 0) {
      let sum = 0;
      for (let addOn of this.addOnsToBuy) {
        if (addOn.checked) {
          sum += addOn.actualPrice;
        }
      }
      return sum;
    }
    return 0;
  }

  //Total amount to pay for addons
  get totalAmountAddedAddons() {
    if (this.addOnsToBuy != null && this.addOnsToBuy.length > 0) {
      let cost = this.addedAddonsActualPrice;
      // return round(cost, 2);
      let total = cost + this.hstAmmountAddons;
      return round(total, 2);
    }
    return 0;
  }

  //hst amount for added addons
  get hstAmmountAddons() {
    if (this.addOnsToBuy != null && this.addOnsToBuy.length > 0) {
      let sum = 0;
      for (let addOn of this.addOnsToBuy) {
        if (addOn.checked) {
          sum += addOn.actualPrice;
        }
      }
      return round(sum * 0.13, 2);
    }
    return 0;
  }

  //Added licenses original price
  get addedLicensesPrice() {
    if (this.userLicensesPriceDto != null) {
      return this.userLicensesPriceDto.originalPrice;
    }
    return 0;
  }

  //Added licenses actual price
  get addedLicensesActualPrice() {
    if (this.userLicensesPriceDto != null) {
      return this.userLicensesPriceDto.actualPrice;
    }
    return 0;
  }

  //Total amount to pay for licenses
  get totalAmountAddedLicenses() {
    if (this.userLicensesPriceDto != null) {
      let cost = this.addedLicensesActualPrice;
      // return round(cost, 2);
      let total = cost + this.hstAmmountLicenses;
      return round(total, 2);
    }
    return 0;
  }

  //hst amount for added licenses
  get hstAmmountLicenses() {
    if (this.userLicensesPriceDto != null) {
      return round(this.userLicensesPriceDto.actualPrice * 0.13, 2);
    }
    return 0;
  }

  get freeUserLicences() {
    return this.accountState.userDetails.freeUserLicenses != null
      ? this.accountState.userDetails.freeUserLicenses
      : 0;
  }

  get paidUserLicences() {
    return this.accountState.userDetails.paidUserLicenses != null
      ? this.accountState.userDetails.paidUserLicenses
      : 0;
  }

  get hasSelectedAddonsToBuy() {
    return this.addOnsToBuy.find((x) => x.checked) != undefined;
  }

  get subscriptionStatus() {
    switch (this.accountState.userDetails.subscriptionStatus) {
    case 0:
      return this.translations.get("ms_draft");
    case 1:
      return this.translations.get("ms_active");
    case 2:
      return this.translations.get("ms_expired");
    case 3:
      return this.translations.get("ms_cancelled");
    default:
      return "";
    }
  }

  get isCreationModeDirect(){
    return this.accountState.userDetails.isTrial && this.accountState.userDetails.creationMode == CustomerCreationMode.Direct;
  }

  get carouselContent() {
    let content: any = [];
    let idIndex = 1;

    for (let i = 0; i < this.selectedPackages.length; i += 4) {
      content.push({
        id: "g" + idIndex,
        props: this.selectedPackages.slice(i, i + 4),
        // Name of the component to be rendered (see vCarousel)
        component: "vPackageCard",
      });
      idIndex++;
    }
    return {
      // meta data about user subscription and other settings
      meta: {
        subscriptionRecurrenceType: this.paymentMode,
        activeSubscription: this.userPackage,
        manageSubscription: true,
      },
      // pages of the carousel
      groups: content,
    };
  }

  //Remove license from add or remove modal
  removeLicenseModal() {
    if (this.addOrRemoveLicensesCount > 0) {
      this.addOrRemoveLicensesCount--;
      this.checkAddingUserLicensesPrice();
    }
  }

  //Add license to add or remove modal
  addLicenseModal() {
    this.addOrRemoveLicensesCount++;
    this.checkAddingUserLicensesPrice();
  }

  checkAddingUserLicensesPrice() {
    if (this.isAddingLicenses) {
      this.paymentLoading = true;
      SubscriptionRepository.checkUserLicensesPrice(
        this.addOrRemoveLicensesCount
      )
        .then((response) => {
          this.userLicensesPriceDto = response.data.result;
          this.paymentLoading = false;
        })
        .catch((error) => {
          this.paymentLoading = false;
        });
    }
  }

  editCreditCard(cardId: number) {
    if (this.paymentMethodToEdit === cardId) {
      this.paymentMethodToEdit = -1;
    }
    else {
      this.paymentMethodToEdit = cardId;
    }
  }

  setPaymentMode(paymentMode: SubscriptionRecurrenceType) {
    this.paymentMode = paymentMode;
  }

  openPaymentModal() {
    this.closeChangeSubscriptionWarningModal();
    if (this.$route.name === "subscriptionPay") {
      this.paymentModalOpen = true;
      //If the subscription is not trial or expired check for subscription migration
      if (
        !this.accountState.userDetails.isTrial &&
        this.accountState.userDetails.subscriptionStatus !==
        this.subscriptionStatusEnum.Expired
      ) {
        let checkSubscriptionMigrationDto: CheckSubscriptionMigration = {
          subscriptionPackageId: parseInt(this.$route.params.id),
          addOns: [],
        };

        SubscriptionRepository.checkSubscriptionMigration(
          checkSubscriptionMigrationDto
        )
          .then((response) => {
            this.subscriptionMigrationDto = response.data.result;
          })
          .catch((error) => {});
      }

      // Track the pay window
      this.$ga.page("/subscription/pay");
    }
  }

  cancelChangeSubscription() {
    this.closeChangeSubscriptionWarningModal();
    // Redirect to the subscription page
    this.$router.push("/subscription");
  }

  openAddAddonsModal() {
    if (
      this.accountState.userDetails.isTrial
      || this.accountState.userDetails.subscriptionStatus === SubscriptionStatus.Expired
    ) {
      this.showTrialUpsellModal = true;
      return;
    }

    this.addAddonsModalOpen = true;
  }

  closeAddAddonsModal() {
    this.paymentLoading = false;
    this.addAddonsModalOpen = false;
  }

  closeFieldEagleActivatedModal() {
    let messageModal = document.getElementById("FieldEagleModalMessage");
    messageModal.style.visibility = "hidden";
  }
  showFieldEagleActivatedMessage() {
    let messageModal = document.getElementById("FieldEagleModalMessage");
    messageModal.style.visibility = "visible";
  }

  openAddOrRemoveLicensesModal() {
    if (
      this.accountState.userDetails.isTrial
      || this.accountState.userDetails.subscriptionStatus === SubscriptionStatus.Expired
    ) {
      this.showTrialUpsellModal = true;
      return;
    }

    this.addOrRemoveLicensesModalOpen = true;
    this.addOrRemoveLicensesCount = typeof this.paidUserLicences == "number" && this.paidUserLicences
      ? this.paidUserLicences
      : 0;
  }

  closeAddOrRemoveLicensesModal() {
    this.paymentLoading = false;
    this.addOrRemoveLicensesModalOpen = false;
  }

  closePaymentModal() {
    this.paymentLoading = false;
    this.paymentModalOpen = false;
    this.payingUserLicenses = 0;
    if (this.$route.name !== "subscription") {
      this.$router.push("/subscription");
    }
  }

  openCancelWarningModal(futureSubscriptionId: number) {
    if (futureSubscriptionId != null && futureSubscriptionId != 0) {
      this.futureSubscriptionId = futureSubscriptionId;
    }
    this.showCancellationSurveyModal = true;
  }

  closeCancellationSurveyModal(){
    this.showCancellationSurveyModal = false;
    this.futureSubscriptionId = 0;
  }

  openChangeSubscriptionWarningModal() {
    this.showChangeSubscriptionWarningModal = true;
  }

  closeChangeSubscriptionWarningModal() {
    this.showChangeSubscriptionWarningModal = false;
  }

  openRemoveAddOnModal(addOnId: number) {
    this.showRemoveAddOnModal = true;
    if (addOnId != null) {
      this.removeAddOnId = addOnId;
    }
  }

  onRemoveAddOn(addOnId: number) {
    if (addOnId != null) {
      if (addOnId == AddOnType.SugarAlcohols) {
        RecipesRepository.hasRecipeWithIngredientsFromSpecificDatabase(
          NutrientSource.SugarAlcohols
        )
          .then((response) => {
            if (response.data.result) {
              this.removeSugarAlcoholAddOnWarning = true;
              this.openRemoveAddOnModal(addOnId);
            }
            else {
              this.removeSugarAlcoholAddOnWarning = false;
              this.openRemoveAddOnModal(addOnId);
            }
          })
          .catch((error) => {
            this.$snotify.error(
              "There has been an error while removing Add-on"
            );
            //Close the modal
            this.closeRemoveAddOnModal();
          });
      }
      else {
        this.removeSugarAlcoholAddOnWarning = false;
        this.openRemoveAddOnModal(addOnId);
      }
    }
  }

  closeRemoveAddOnModal() {
    this.showRemoveAddOnModal = false;
    this.removeAddOnId = null;
  }

  removeSelectedAddOn() {
    // if (
    //   this.accountState.userDetails.subscriptionPaymentProvider ==
    //   this.paymentProviderEnum.Braintree
    // ) {
    if (
      this.accountState.userDetails.subscriptionPaymentProvider ==
      this.paymentProviderEnum.Braintree &&
      this.accountState.userDetails.featureFlagPaymentProvider ==
      this.paymentProviderEnum.FastSpring
    ) {
      let subscriptionName =
        this.accountState.userDetails.subscriptionPackageExternalId;
      // this.openFastSpringModal(subscriptionName.toLowerCase(), 1);
      this.transveringSubscriptionId = subscriptionName.toLowerCase();
      this.transveringPaymentCost = 0;
      this.isTransferingPaymentProviderModalOpen = true;
    }
    else {
      this.removeAddOnFromCurrentSubscription(null);
    }
    this.closeRemoveAddOnModal();
  }

  removeAddOnFromCurrentSubscription(orderId: number) {
    const RemoveAddOnDto = {
      addOn: this.removeAddOnId,
      orderId: orderId,
    };

    SubscriptionRepository.removeAddOnFromCurrentSubscription(RemoveAddOnDto)
      .then((response) => {
        //Show success message
        this.$snotify.success(
          "The Add-on was removed from the current subscription."
        );
        //Get User Details with updated Addons
        this.$store.dispatch(FETCH_USER_DETAILS);
        //Close the modal
        this.closeRemoveAddOnModal();
      })
      .catch((error) => {
        this.$snotify.error("There has been an error while removing Add-on");
        //Close the modal
        this.closeRemoveAddOnModal();
      });
  }

  openFutureSubscriptionDetailsModal(id: number) {
    this.showFutureSubscriptionDetailsModal = true;
    this.futureSubscription = this.futureSubscriptions.find((x) => x.id === id);
  }

  closeFutureSubscriptionDetailsModal() {
    this.showFutureSubscriptionDetailsModal = false;
    this.futureSubscription = null;
  }

  isManagedSubscription() {
    if (
      this.accountState.userDetails.subscriptionEndDate &&
      !this.accountState.userDetails.isTrial &&
      this.accountState.userDetails.subscriptionStatus !==
      this.subscriptionStatusEnum.Expired
    ) {
      if (this.isDowngrade) {
        return true;
      }
      else if (!this.isDowngrade && !this.isUpgrade) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  async openFastSpringModal(subscriptionId : string, subscriptionCost : number) {
    // loader initiated
    this.subscriptionLoader = true;
    let subscriptionPayload = {
      items: [
        {
          product: !this.isManagedSubscription()
            ? subscriptionId
            : "brain-tree-migration-package",
          quantity: 1,
          pricing: {
            price: {
              USD: !this.isDowngrade ? subscriptionCost : 0,
            },
          },
        },
      ],
      contact: {
        email: this.restaurantNotificationEmail,
      },
    };

    let payloadForEncryption = JSON.stringify(subscriptionPayload);

    SubscriptionRepository.generateSecurePayload(payloadForEncryption).then(
      async(response) => {
        let secure: {
          secure?: { payload: any, key: string },
          reset: boolean,
          tags: { source: string }
        } = {
          reset: true,
          tags: {
            source: "web",
          },
        };

        secure["secure"] = {
          payload: response.data.securePayload,
          key: response.data.secureKey,
        };

        // fastspring.builder.push(secure);

        setTimeout(() => {
          this.subscriptionLoader = false;
          let sale = { checkout: true };
          // fastspring.builder.clean();
          // fastspring.builder.push(sale);
        }, 5000);
      },
      (error) => {
        // TODO: handle generateSecurePayload error
        this.subscriptionLoader = false;
      }
    );

    if (this.paymentProcessInterval == null) {
      let context = this;
      this.paymentProcessInterval = setInterval(async function() {
        let paymentModalData = (<any>window).paymentModalData;
        if (paymentModalData != null && paymentModalData != undefined) {
          if (context.addOrRemoveLicensesModalOpen) {
            context.addOrRemoveUserLicenses(paymentModalData.id);
          }
          else if (context.addAddonsModalOpen) {
            context.payForAddedAddons(paymentModalData.id);
          }
          else if (context.showRemoveAddOnModal) {
            context.removeAddOnFromCurrentSubscription(paymentModalData.id);
          }
          else {
            // context.payForSubscription(paymentModalData.id);
          }

          context.stopInterval();
          // close modal
          context.closePaymentModal();
        }
      }, 2000);
    }
  }

  proceedToFastspringCheckout() {
    this.isTransferingPaymentProviderModalOpen = false;
    this.openFastSpringModal(
      this.transveringSubscriptionId,
      this.transveringPaymentCost
    );
  }

  stopInterval() {
    clearInterval(this.paymentProcessInterval);
    this.paymentProcessInterval = null;
    (<any>window).paymentModalData = null;
  }

  openFastSpringModalforOneTimePayment() {
    // if (
    //   this.accountState.userDetails.subscriptionPaymentProvider ==
    //   this.paymentProviderEnum.Braintree
    // ) {
    if (
      this.accountState.userDetails.subscriptionPaymentProvider == this.paymentProviderEnum.Braintree
      && this.accountState.userDetails.featureFlagPaymentProvider == this.paymentProviderEnum.FastSpring
    ) {
      let subscriptionName =
        this.accountState.userDetails.subscriptionPackageExternalId;
      // let subscriptionName = `${this.accountState.userDetails.subscriptionName.toLowerCase()}-${
      //   this.accountState.userDetails.subscriptionCycle == 0
      //     ? "monthly"
      //     : "yearly"
      // }`;
      // this.openFastSpringModal(
      //   subscriptionName.toLowerCase(),
      //   this.totalAmountAddedLicenses != 0 ? this.totalAmountAddedLicenses : 1
      // );
      this.transveringSubscriptionId = subscriptionName.toLowerCase();
      this.transveringPaymentCost =
        this.totalAmountAddedLicenses != 0 ? this.totalAmountAddedLicenses : 0;
      this.isTransferingPaymentProviderModalOpen = true;
    }
    else {
      this.addOrRemoveUserLicenses(null);
    }
  }

  payForAddOns() {
    if (
      this.accountState.userDetails.subscriptionPaymentProvider ==
      this.paymentProviderEnum.Braintree &&
      this.accountState.userDetails.featureFlagPaymentProvider ==
      this.paymentProviderEnum.FastSpring
    ) {
      let subscriptionName =
        this.accountState.userDetails.subscriptionPackageExternalId;
      // this.openFastSpringModal(
      //   subscriptionName.toLowerCase(),
      //   this.totalAmountAddedAddons
      // );
      this.transveringSubscriptionId = subscriptionName.toLowerCase();
      this.transveringPaymentCost = this.totalAmountAddedAddons;
      this.isTransferingPaymentProviderModalOpen = true;
    }
    else {
      this.payForAddedAddons(null);
    }
  }

  addOrRemoveUserLicenses(orderId: number) {
    this.paymentLoading = true;
    //Add licenses to the current subscription
    if (this.isAddingLicenses) {
      if (this.chosenPaymentMethodId == -1) {
        this.paymentLoading = false;
        this.$snotify.error("Please check payment methods.");
        return;
      }
      const BuyUserLicensesDto = {
        paidUserLicenses: this.addOrRemoveLicensesCount - this.paidUserLicences,
        orderId: orderId,
        paymentMethodId: this.chosenPaymentMethodId,
      };
      SubscriptionRepository.buyUserLicenses(BuyUserLicensesDto)
        .then(() => {
          this.$snotify.success(
            "Payment request was sent to our payment provider."
          );
          // close modal
          this.closeAddOrRemoveLicensesModal();
          this.shortPollUserDetails();
        })
        .catch((error) => {
          let message = "";
          if (
            error.response &&
            error.response.data != null &&
            error.response.data.errorMessages != null &&
            error.response.data.errorMessages.length > 0
          ) {
            message = error.response.data.errorMessages[0].userVisibleMessage;
          }
          else {
            message = this.translations.get("network_error");
          }
          this.$snotify.error(message);
          this.paymentLoading = false;
        });
    }
    else {
      //Remove licenses from the current subscription
      const RemoveUserLicensesDto = {
        paidUserLicenses: this.addOrRemoveLicensesCount,
        orderId: orderId,
      };
      SubscriptionRepository.removeUserLicenses(RemoveUserLicensesDto)
        .then(() => {
          //Show a success message
          this.$snotify.success(
            "The User Licenses were removed from the current subscription."
          );
          // close modal
          this.closeAddOrRemoveLicensesModal();
          //Get User Details with updated Addons
          this.$store.dispatch(FETCH_USER_DETAILS);
        })
        .catch((error) => {
          this.$snotify.error(
            error.response.data.errorMessages[0].userVisibleMessage
          );
          //Close the modal
          this.closeAddOrRemoveLicensesModal();
        });
    }
  }
  // Pay for addons added to the current subscription
  payForAddedAddons(orderId: number) {
    this.paymentLoading = true;
    if (this.chosenPaymentMethodId == -1) {
      this.paymentLoading = false;
      this.$snotify.error("Please check payment methods.");
      return;
    }
    //If the total amount to pay is greater than zero then check payment info
    if (this.totalAmountAddedAddons > 0) {
      //Check if there is payment method selected
      const BuyAddOnsDto = {
        addOns: this.addOnsToBuy
          .filter((x) => x.checked)
          .map((addon, index) => {
            return addon.addOn;
          }),
        orderId: orderId,
        paymentMethodId: this.chosenPaymentMethodId,
      };
      SubscriptionRepository.buyAddOns(BuyAddOnsDto)
        .then(() => {
          this.$snotify.success(
            "Payment request was sent to our payment provider."
          );
          // close modal
          this.closeAddAddonsModal();
          this.shortPollUserDetails();
          //List Add-ons to buy
          this.listAddOnsToBuy();
          // If Field Eagle Addon is activated
          if (BuyAddOnsDto.addOns.includes(2)) {
            this.showFieldEagleActivatedMessage();
          }
        })
        .catch((error) => {
          let message = "";
          if (
            error.response &&
            error.response.data != null &&
            error.response.data.errorMessages != null &&
            error.response.data.errorMessages.length > 0
          ) {
            message = error.response.data.errorMessages[0].userVisibleMessage;
          }
          else {
            message = this.translations.get("network_error");
          }
          this.$snotify.error(message);
          this.paymentLoading = false;
        });
    }
    else {
      const BuyAddOnsDto = {
        addOns: this.addOnsToBuy
          .filter((x) => x.checked)
          .map((addon, index) => {
            return addon.addOn;
          }),
        orderId: orderId,
        paymentMethodId: -1,
      };
      SubscriptionRepository.buyAddOns(BuyAddOnsDto)
        .then(() => {
          this.$snotify.success(
            "The selected Add-ons are successfully activated"
          );
          this.shortPollUserDetails();
          // close modal
          this.closeAddAddonsModal();
          //List Add-ons to buy
          this.listAddOnsToBuy();
          // If Field Eagle Addon is activated
          if (BuyAddOnsDto.addOns.includes(2)) {
            this.showFieldEagleActivatedMessage();
          }
        })
        .catch((error) => {
          let message = "";
          if (
            error.response &&
            error.response.data != null &&
            error.response.data.errorMessages != null &&
            error.response.data.errorMessages.length > 0
          ) {
            message = error.response.data.errorMessages[0].userVisibleMessage;
          }
          else {
            message = this.translations.get("network_error");
          }
          this.$snotify.error(message);
          this.paymentLoading = false;
        });
    }
  }

  async onPaymentModalSuccess(chosenAddons: AddOnType[]) {
    this.closePaymentModal();

    // await this.$store.dispatch(FETCH_USER_DETAILS);
    await this.shortPollUserDetails();

    // If this is a downgrade, get future subscriptions
    if (this.isDowngrade) {
      this.getFutureSubscriptions();
    }

    // If Field Eagle Addon is activated
    setTimeout(() => {
      if (chosenAddons.some((x) => x == 2) && !this.isDowngrade) {
        this.showFieldEagleActivatedMessage();
      }
    }, 1000);

    this.$ga.page("/subscription/success");
    // await this.$router.push("/");

    this.$snotify.success("Your subscription has been updated.");

    const intervalMs = 5000;
    const maxTime = 30000;
    let elapsed = 0;

    const intervalHandle = setInterval(async() => {
      elapsed += intervalMs;

      await this.$store.dispatch(FETCH_USER_DETAILS);

      if (!this.accountState.userDetails.hasDraftSubscription) {
        clearInterval(intervalHandle);
        await this.$router.push("/");
        return;
      }

      // Stop polling after 30 seconds
      if (elapsed >= maxTime) {
        clearInterval(intervalHandle);
        this.$snotify.info("Your payment is still processing.");
        return;
      }
    }, intervalMs);
  }

  onPaymentModalError() {
    this.shortPollUserDetails();
  }

  async shortPollUserDetails() {
    await this.fetchCookiedPackages();
    await this.$store.dispatch(FETCH_USER_DETAILS);
  }

  submitCancelSubscription(exitSurveyDto: ExitSurveyDto) {
    if (this.futureSubscriptionId == 0) {
      //Cancel subscription
      SubscriptionRepository.cancelSubscription().then((response) => {
        // show success message
        this.$snotify.success(this.translations.get("ms-success-cancel"));
        this.submitCancellationSurvey(exitSurveyDto);
        this.$store.dispatch(FETCH_USER_DETAILS);
      });
    }
    else {
      //Cancel future subscription
      SubscriptionRepository.cancelFutureSubscription(this.futureSubscriptionId)
        .then((response) => {
          // show success message
          this.$snotify.success(
            this.translations.get("ms_cancel_future_subscription")
          );
          this.submitCancellationSurvey(exitSurveyDto);
          this.$store.dispatch(FETCH_USER_DETAILS);
          this.getFutureSubscriptions();
        })
        .catch((error) => {
          this.getFutureSubscriptions();
        });
    }

  }

  getFormatedDate(date: Date) {
    return this.$moment(date).format(dateDisplayFormat);
  }

  submitCancellationSurvey(exitSurvey: ExitSurveyDto){
    SubscriptionRepository.createExitSurvey(exitSurvey).then(()=>{
      this.$snotify.success("Feedback survey submitted!");
    })
      .catch(()=>{});
  }

  submitCancelSubscriptionEvent(exitSurveyDto: ExitSurveyDto) {
    this.submitCancelSubscription(exitSurveyDto);
  }

  submitRetentionSelectionEvent(payload: any) {
    const exitSurveyDto: ExitSurveyDto = payload?.exitSurvey || payload;
    const claimRequest = payload?.claimRequest;
    const claimed = !!payload?.claimed;

    const finalizeRetention = () => {
      this.submitCancellationSurvey(exitSurveyDto);
      this.$store.dispatch(FETCH_USER_DETAILS);
      this.fetchCookiedPackages();
      this.getFutureSubscriptions();

      if (!claimed) {
        this.closeCancellationSurveyModal();
        this.$snotify.success("Thanks for the feedback. Your subscription is still active.");
      }
    };

    if (!claimRequest) {
      finalizeRetention();
      return;
    }

    CancellationWorkflowRepository.claimRetentionOffer(claimRequest)
      .then(() => {
        finalizeRetention();
      })
      .catch(() => {
        this.$snotify.error("We couldn’t apply the retention offer right now.");
      });
  }

  getAddOnName(addOnType: number) {
    switch (addOnType) {
    case 0:
      return AddOnTypeName[0];
    case 1:
      return AddOnTypeName[1];
    case 2:
      return AddOnTypeName[2];
    case 3:
      return AddOnTypeName[3];
    case 4:
      return AddOnTypeName[4];
    default:
      return "";
    }
  }

  async fetchCookiedPackages() {
    SubscriptionRepository.displaySubscriptionPackages()
      .then((response) => {
        this.packages = response.data.result;
      })
      .catch((error) => {});
  }

  getFutureSubscriptions() {
    SubscriptionRepository.listFutureSubscriptions()
      .then((response) => {
        this.futureSubscriptions = response.data.result;
      })
      .catch((error) => {});
  }

  listAddOnsToBuy() {
    SubscriptionRepository.listAddOnsToBuy()
      .then((response) => {
        this.addOnsToBuy = response.data.result;
        // let hasFieldEagleAddOn = this.addOnsToBuy.some((x) => x.addOn == 2);
        // if(!hasFieldEagleAddOn) {
        //   this.addOnsToBuy.push({});
        // }
      })
      .catch((error) => {});
  }

  ShowGPWarningModal(){
    //Checks if account is trial and if package is legacy
    if(!this.accountState.userDetails.isTrial && this.accountState.userDetails.isLegacySubscription) {
      //checks if the package has not expired and has been cancelled.
      if(this.accountState.userDetails.subscriptionStatus !== this.subscriptionStatusEnum.Expired && !this.accountState.userDetails.isRecurring){
        return false;
      }
      //checks if the package has not expired and has not been cancelled.
      else if(this.accountState.userDetails.subscriptionStatus !== this.subscriptionStatusEnum.Expired && this.accountState.userDetails.isRecurring){
        return true;
      }
      //checks if the package has expired.
      else if(this.accountState.userDetails.subscriptionStatus === this.subscriptionStatusEnum.Expired){
        return false;
      }
    }
    else{
      return false;
    }
  }

  get translations() {
    return this.localizationState.translations;
  }

  get selectedPackages() {
    if (this.paymentMode == 0) {
      return this.packages.filter((x) => x.cycle == 0);
    }
    else {
      return this.packages.filter((x) => x.cycle == 1);
    }
  }

  get isFutureSubscriptionOnBraintree() {
    if (
      (this.accountState.userDetails.isTrial &&
        this.accountState.userDetails.featureFlagPaymentProvider ===
        this.paymentProviderEnum.Braintree) ||
      (this.accountState.userDetails.featureFlagPaymentProvider ===
        this.paymentProviderEnum.Braintree &&
        this.accountState.userDetails.subscriptionPaymentProvider ==
        this.paymentProviderEnum.Braintree)
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  mounted() {}

  created() {
    // this.accountState.userDetails.paymentProvider = 0;
    this.$store
      .dispatch(TRANSLATIONS_FETCH, {
        category: "pages",
        collections: [
          "common",
          "managesubscription",
          "packages",
          "addons",
          "managePayment",
          "profile",
        ],
      })
      .then(() => {
        document.title =
          this.translations.get("ms_title") +
          " " +
          this.translations.get("meta_title_postfix");
      });

    this.showCarouselPreloader = true;

    //Get the subscription packages and display them
    SubscriptionRepository.displaySubscriptionPackages()
      .then((response) => {
        this.showCarouselPreloader = false;
        this.packages = response.data.result;
      })
      .catch(() => {});

    //Get future subscription if exists
    this.getFutureSubscriptions();

    //List Add-ons to buy
    this.listAddOnsToBuy();

    if (this.$route.name === "subscriptionPay") {
      // NOTE: We check if the user is on a trial here in case the default trial package
      // Gets marked as legacy, which would show the modal to change subscription for them
      if (this.ShowGPWarningModal()) {
        this.openChangeSubscriptionWarningModal();
      }
      else {
        this.openPaymentModal();
      }

      let bodee = document.getElementsByTagName("body")[0];
      bodee.classList.add("modalOpen");
    }

    if (this.$route.query.trialExpired) {
      this.showTrialEndUpsellModal = true;
    }

    // The client requested the yearly recurrence to be active as default
    this.setPaymentMode(1);
    if (this.$route.params.subscriptionCycle) {
      let subscriptionCycle = parseInt(this.$route.params.subscriptionCycle);
      this.setPaymentMode(subscriptionCycle);
    }
  }

  beforeDestroy() {
    this.stopInterval();
  }
}
export default ManageSubscription;
